module.exports = __webpack_public_path__ + "media/images/logos/watermark-white-6c61e62010d8e11b457d97f03f452782.svg";